"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccordionMenu extends HTMLLIElement {
    constructor() {
        super();
        this.childMenu = this.querySelector('ul');
        this.button = this.querySelector('button');
        if (this.childMenu && this.button) {
            if (!this.childMenu.id) {
                this.childMenu.id = this.childId;
            }
            this.button.setAttribute('aria-controls', this.childMenu.id);
            this.button.addEventListener('click', () => this.toggle());
        }
        this.close();
    }
    open() {
        var _a;
        if (this.childMenu === null) {
            return;
        }
        this.childMenu.hidden = false;
        (_a = this.button) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'true');
    }
    close() {
        var _a;
        if (this.childMenu === null) {
            return;
        }
        this.childMenu.hidden = true;
        (_a = this.button) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
    }
    toggle() {
        if (this.isOpen()) {
            this.close();
        }
        else {
            this.open();
        }
    }
    isOpen() {
        if (this.childMenu === null) {
            return false;
        }
        return !this.childMenu.hidden;
    }
    get childId() {
        if (this.parentElement === null) {
            throw new Error();
        }
        if (!this.parentElement.id) {
            throw new Error('The parent menu requires an ID property');
        }
        const index = Array.from(this.parentElement.children).indexOf(this);
        return `${this.parentElement.id}-${index}`;
    }
}
exports.default = AccordionMenu;
